export default function translate(i18n, propriete) {
  if (propriete === '[0].MontantAnnuelHt') {
    return i18n.t('listeContratReconductible.popUpReconduction.error.translate.montantAnnuelHt');
  }
  if (propriete === '[0].nMoisReconduction' || propriete === '[0].NMoisReconduction') {
    return i18n.t('listeContratReconductible.popUpReconduction.error.translate.reconductionContrat');
  }
  if (propriete === '[0].quantitePeriodicite' || propriete === '[0].QuantitePeriodicite') {
    return i18n.t('listeContratReconductible.popUpReconduction.error.translate.tousLes');
  }
  return propriete;
}
